import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { SEModule } from '@delon/abc/se';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { EInvoiceService } from 'src/app/core/services/e-invoice.service';
import { FormService } from 'src/app/core/util/form.service';
import { InputModule } from 'src/app/input/input.module';

@Component({
  selector: 'app-tariff-code-edit-modal',
  templateUrl: './tariff-code-edit-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NzInputModule,
    NzModalModule,
    SEModule,
    InputModule
  ]
})
export class TariffCodeEditModalComponent implements OnInit {
  form = this.fb.group({
    code: ['', [Validators.required, Validators.maxLength(20)]],
    description: ['', [Validators.required, Validators.maxLength(1000)]],
    isActive: [false, []],
    isDefault: [false, []]
  });
  data: any = {};
  isVisible = false;

  @Input() forceIsActive = false;
  @Input() forceIsDefault = false;

  @Output() readonly selectTariffCode: EventEmitter<any> =
    new EventEmitter<any>();
  @Output() readonly getTariffCodeId: EventEmitter<any> =
    new EventEmitter<any>();

  constructor(
    private fb: FormBuilder,
    private fs: FormService,
    public eInvoiceSrv: EInvoiceService
  ) { }

  ngOnInit(): void {
    return;
  }

  showNew(data: any) {
    this.form.patchValue(data);
    if (this.forceIsActive) this.form.controls.isActive.setValue(true);
    if (this.forceIsDefault) this.form.controls.isDefault.setValue(false);
    this.isVisible = true;
  }

  handleOk() {
    if (!this.fs.validate(this.form).isValid) return;

    this.selectTariffCode.emit(this.form.value);
    this.form.controls.code.setValue('');
    this.form.controls.description.setValue('');
    this.isVisible = false;
  }
}
